export default "__VITE_ASSET__BqDbfezf__"